import { CollapsibleRowMenuButton } from 'components/collapsible-row-menu';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvTooltip from 'shared/components/nv-tooltip';
import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';

type ToggleResponseVisibilityButtonProps = {
  hideMentorResponse: boolean;
  disabled?: boolean;
  onClick: () => void;
};

const ToggleResponseVisibilityButton = (props: ToggleResponseVisibilityButtonProps) => {
  const { hideMentorResponse, disabled, onClick } = props;

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const aliases = useSelector((state) => getMentoringProgramAliases(state, mentoringProgram?.id ?? 0));

  const translations = useMemo(() => (
    t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.RESPONSE_VISIBILITY
  ), []);

  const icon = hideMentorResponse ? 'view' : 'hide';
  const label = hideMentorResponse
    ? translations.SHOW()
    : translations.HIDE({ MentorAlias: aliases.MentorAlias ?? '', MenteeAlias: aliases.MenteeAlias ?? '' });
  const dataQa = useMemo(() => (
    config.pendo.athena.mentorshipProgram.settings.programProfileSetup.toggleResponseVisibilityButton ?? ''
  ), []);

  return (
    <NvTooltip
      text={label}
      placement='top'
      maxWidth={240}
      enabled={!disabled}
    >
      <div className='d-flex'>
        <CollapsibleRowMenuButton
          icon={icon}
          onClick={onClick}
          disabled={disabled}
          data-qa={dataQa}
          aria-label={label}
        />
      </div>
    </NvTooltip>
  );
};

export default React.memo(ToggleResponseVisibilityButton);
